import { Navigate } from 'react-router-dom';

export default () => <Navigate to="/profile" replace />;
